import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import type { DbPortalIch } from '@gql/shared-types';
import { api, ApiFehler } from '../api/client.js';
import { datenCacheLeeren } from '../daten/laden.js';

type AuthZustand =
  | { status: 'laedt' }
  | { status: 'fehler'; meldung: string }
  | { status: 'bereit'; ich: DbPortalIch };

interface AuthWert {
  zustand: AuthZustand;
  neuLaden: () => Promise<void>;
  abmelden: () => Promise<void>;
}

const Kontext = createContext<AuthWert | null>(null);

export function AuthAnbieter({ children }: { children: ReactNode }) {
  const [zustand, setZustand] = useState<AuthZustand>({ status: 'laedt' });
  const neuLaden = useCallback(async () => {
    try {
      setZustand({ status: 'bereit', ich: await api<DbPortalIch>('/ich') });
    } catch (e) {
      setZustand({ status: 'fehler', meldung: e instanceof ApiFehler ? e.message : 'Unerwarteter Fehler.' });
    }
  }, []);
  const abmelden = useCallback(async () => {
    try {
      await api('/abmelden', { methode: 'POST' });
    } finally {
      datenCacheLeeren();
      await neuLaden();
    }
  }, [neuLaden]);
  useEffect(() => {
    void neuLaden();
  }, [neuLaden]);
  return <Kontext.Provider value={{ zustand, neuLaden, abmelden }}>{children}</Kontext.Provider>;
}

export function useAuth(): AuthWert {
  const wert = useContext(Kontext);
  if (!wert) throw new Error('useAuth außerhalb von AuthAnbieter');
  return wert;
}
